export default __webpack_public_path__ + "static/media/APL.38cb57bb.png";